import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Loader = ({ isLoading }) => (
  <S.Container isLoading={isLoading}>
    <S.Loader>
      <S.Clock />
      <S.Balls />
    </S.Loader>
  </S.Container>
);

export default Loader;

Loader.defaultProps = {
  isLoading: true,
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
};
